var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"title":'Send Message',"active":_vm.modals.sendMessage,"size":"xl"},on:{"update:active":function($event){return _vm.$set(_vm.modals, "sendMessage", $event)}}},[_c('shared-send-message')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }